import axiosClient from "utils/api/axios-client";

const api = {
  getConfig: () => {
    const url = "/api/v1/super-config/config";
    return axiosClient.get(url);
  },
  updateConfig: (data) => {
    const url = "/api/v1/super-config/config";
    return axiosClient.put(url, data);
  },
  scanViolatingRestaurants: () => {
    const url = "/api/v1/super-config/scan-violating-restaurants";
    return axiosClient.get(url);
  },
};

export default api;
